document.addEventListener('click', function(e) {
  const scrollDownHome = document.getElementById('scroll-down-home');
  if(scrollDownHome && e.target.id === 'scroll-down-home'){
    const homeTrails = document.getElementById('home-trails');
    if(homeTrails) homeTrails.scrollIntoView({behavior: "smooth"});
  }
});
